import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import cn from 'classnames';
import { DataLossPreventionStore } from '../../stores/BrowserPolicies/DLPStore';
import Box from '../Box/Box';
import SearchField from '../SearchField/SearchField';
import Toggle from '../Toggle/Toggle';
import Dropdown from '../Dropdown';
import Button from '../Button';
import ConsoleField from '../ConsoleFragments/ConsoleField';
import PasteLimitField from './PasteLimitField';
import DomainConfigurationModal from './DomainConfigurationModal';
import './DataLossPrevention.css';

const block = b_.lock('DataLossPrevention');

class DataLossPrevention extends Component {
    static propTypes = {
        dlp: DataLossPreventionStore.PropType.isRequired,
    };

    renderTableHeader() {
        return (
            <div className={block('Tr', { header: true })}>
                <div className={block('Td', { header: true, type: 'domain' })}>
                    Domain
                </div>
                <div className={block('Td', { header: true, type: 'allInput' })}>
                    All input
                </div>
                <div className={block('Td', { header: true, type: 'paste' })}>
                    Paste
                </div>
                <div className={block('Td', { header: true, type: 'menu' })}>&nbsp;</div>
            </div>
        );
    }

    renderAbility = (isAble, isLimited = false, limit) => {
        if (isAble) {
            if (isLimited) {
                return <span className={block('DomainStatus', { limited: true })}>Limited ({limit} chars)</span>;
            }

            return <span className={block('DomainStatus', { enabled: true })}>Enabled</span>;
        }

        return <span className={block('DomainStatus', { disabled: true })}>Disabled</span>;
    };

    renderRow = (domainConfigStore, index) => {
        const { dlp } = this.props;
        const { options } = domainConfigStore;

        return (
            <div key={index} className={block('Tr', { focused: dlp.menuId === index })}>
                <div className={block('Td', { type: 'domain' })}>
                    {domainConfigStore.domainStore.value}
                </div>
                <div className={block('Td', { type: 'allInput' })}>
                    {this.renderAbility(!options.allInputStore.isEnabled)}
                </div>
                <div className={block('Td', { type: 'paste' })}>
                    {this.renderAbility(
                        !options.clipboardPasteStore.isEnabled,
                        options.pasteLimitEnabledStore.isEnabled,
                        options.pasteLimitStore.value
                    )}
                </div>

                <div className={block('Td', { type: 'menu' })}>
                    {<Button
                        className={block('ToggleMenu')}
                        icon="more_vert"
                        onClick={() => dlp.toggleMenu(index)}
                    />}

                    {dlp.menuId === index ? <Dropdown
                        className={block('Menu')}
                        onClose={() => dlp.toggleMenu(null)}
                    >
                        <Button
                            className={block('MenuItem')}
                            icon="edit"
                            onClick={() => {
                                dlp.showEditDomainConfigurationModal(domainConfigStore, index);
                                dlp.toggleMenu(null);
                            }}
                            fullWidth
                            noCenter
                        >Edit Domain…</Button>

                        <Button
                            className={block('MenuItem')}
                            icon="delete"
                            onClick={() => {
                                dlp.removeDomain(index);
                                dlp.toggleMenu(null);
                            }}
                            fullWidth
                            noCenter
                        >Delete Domain</Button>
                    </Dropdown> : null}
                </div>
            </div>
        );
    };

    renderDefaultSettings() {
        const { defaults } = this.props.dlp;

        return (
            <Box
                theme="light"
                className={block('SubBoxWrapper')}
                title={'Default Settings'}
                titleClassName={block('SubBoxTitle')}
            >
                <div className={block('DefaultSettingsContent')}>
                    <ConsoleField
                        className={block('ConsoleField')}
                        name="All Input"
                        info="All input includes keyboard, clipboard paste."
                        infoPosition="right"
                    >
                        <Toggle
                            onLabel={'ENABLED'}
                            offLabel={'DISABLED'}
                            checked={!defaults.allInputStore.isEnabled}
                            onChange={defaults.allInputStore.toggle}
                        />
                    </ConsoleField>

                    <ConsoleField
                        className={block('ConsoleField')}
                        name="Clipboard Paste"
                        info="Optionally disabled clipboard paste."
                        disabled={defaults.allInputStore.isEnabled}
                    >
                        <Toggle
                            onLabel={'ENABLED'}
                            offLabel={'DISABLED'}
                            checked={!defaults.clipboardPasteStore.isEnabled}
                            onChange={defaults.clipboardPasteStore.toggle}
                        />
                    </ConsoleField>

                    <ConsoleField
                        className={block('ConsoleField')}
                        name="Paste Limit"
                        info="Optionally enabled a character limit for pasted content."
                        disabled={defaults.clipboardPasteStore.isEnabled}
                    >
                        <Toggle
                            onLabel={'ENABLED'}
                            offLabel={'DISABLED'}
                            checked={defaults.pasteLimitEnabledStore.isEnabled}
                            onChange={defaults.pasteLimitEnabledStore.toggle}
                        />
                    </ConsoleField>

                    <ConsoleField
                        className={block('ConsoleField')}
                        name="Paste Limit Maximum"
                        info="Maximum number of characters a user can paste."
                        infoPosition="left"
                        disabled={
                            !defaults.pasteLimitEnabledStore.isEnabled ||
                            defaults.clipboardPasteStore.isEnabled
                        }
                    >
                        <PasteLimitField store={defaults.pasteLimitStore} />
                    </ConsoleField>
                </div>
            </Box>
        );
    }

    renderDomainSpecificSettings() {
        return (
            <Box
                theme="light"
                className={cn(block('SubBoxWrapper'), block('DomainSpecificSettingsWidget'))}
                title={this.renderDomainSpecificBoxTitle()}
                titleClassName={block('SubBoxTitle')}
            >
                <div className={block('Table')}>
                    {this.renderTableHeader()}
                    {this.props.dlp.filteredDomains.map(this.renderRow)}
                </div>
            </Box>
        );
    }


    renderDomainSpecificBoxTitle = () => {
        return (
            <div className={block('DomainSpecificSettingsTitleBlock')}>
                <div className={block('DomainSpecificSettingsTitle')}>
                    Domain Specific Settings
                </div>
                <div className={block('DomainSpecificSearchBar')}>
                    <SearchField inputStore={this.props.dlp.search} placeholder={'Search Domains'} />
                </div>
                <div className={block('DomainSpecificAddButtonWrap')}>
                    <Button
                        primary
                        raised
                        icon="add"
                        className={block('DomainSpecificAddButton')}
                        onClick={() => this.props.dlp.showCreateDomainConfigurationModal()}
                    >
                        New Domain
                    </Button>
                </div>
            </div>
        );
    };

    render() {
        return (
            <Box
                theme="light"
                title={'KEYBOARD AND PASTE CONTROLS'}
                className={block('GeneralBoxWrapper')}
                titleClassName={block('GeneralBoxTitle')}
            >
                <div className={block('AllInputSettingsContent')}>
                    {this.renderDefaultSettings()}
                    {this.renderDomainSpecificSettings()}
                    <DomainConfigurationModal dlp={this.props.dlp} />
                </div>
            </Box>
        );
    }
}

export default observer(DataLossPrevention);
